import { z } from 'zod';

export const emailValidateSchema = z.object({
  email: z.string().email("El correo electrónico es requerido"),
});

export const RecoverCertificateItemSchema = z.object({
  id_request_certificate: z.union([z.string(), z.number()]),
  number: z.union([z.string(), z.number()]).nullable().optional(),
  pin: z.string().nullable().optional(),
  observation: z.string().nullable().optional(),
  created_at: z.union([z.string(), z.date()]),
  state: z
    .object({
      description: z.string(),
    })
    .nullable()
    .optional(),
  office: z
    .object({
      value: z.union([z.string(), z.number()]),
      description: z.string().optional(),
    })
    .nullable()
    .optional(),
  refund: z
    .object({
      id_state: z.number().nullable().optional(),
    })
    .nullable()
    .optional(),
});

export const RecoverRequestsResponseSchema = z.object({
  status: z.number(),
  message: z.string(),
  data: z.array(RecoverCertificateItemSchema).optional(),
  error: z.string().optional(),
});

export const ResendCodeParamSchema = z.object({
  id: z.union([z.string(), z.number()]).refine((val) => String(val).trim().length > 0, {
    message: 'El id es requerido',
  }),
});

export const ResendCodeResponseSchema = z.object({
  status: z.number(),
  message: z.string(),
  data: z.any().optional(),
});

export type EmailValidateInput = z.infer<typeof emailValidateSchema>;
export type RecoverCertificateItem = z.infer<typeof RecoverCertificateItemSchema>;
export type RecoverRequestsResponse = z.infer<typeof RecoverRequestsResponseSchema>;
export type ResendCodeParamInput = z.infer<typeof ResendCodeParamSchema>;
export type ResendCodeResponse = z.infer<typeof ResendCodeResponseSchema>;

